import BaseModel from '../core/BaseModel'
export default class ListHistoryUpdateRepairSerialModel extends BaseModel {
    constructor() {
        super({ 
                name: "list_history_update_repair_serial",
                tableName: 'core_warranty_repair_product_sn_history_update'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            modified_date: {
                name: 'modified_date',
                type: "CustomDateTime",
                label: 'Thời gian cập nhật',
                class: 'top-datepicker',
                width: 15,
            },
                modifier_info: {
                    name: 'modifier_info',
                    type: "String",
                    label: 'Người cập nhật',
                    width: 15,
                    computed: (data) => {
                        var modifier_info = "";
                        if (data.obj_modifier){
                            modifier_info = (data.obj_modifier.full_name) ? data.obj_modifier.full_name:'';
                        }
                        data.modifier_info = modifier_info;
                    }
                },
                organization_modifier_info: {
                    name: 'organization_modifier_info',
                    type: "String",
                    label: 'Đơn vị cập nhật',
                    width: 15,
                    computed: (data) => {
                        var organization_modifier_info = "Khách hàng";//Nếu ko tồn tại đơn vị thì là khách hàng
                        if (data.obj_modifier){
                            if (data.obj_modifier.organization_account){
                                if (data.obj_modifier.organization_account.organization){
                                    organization_modifier_info = (data.obj_modifier.organization_account.organization.name) ? data.obj_modifier.organization_account.organization.name:'';
                                }
                            }
                        }
                        data.organization_modifier_info = organization_modifier_info;
                    }
                },
                /*content: {
                    name: 'content',
                    type: "String",
                    label: 'Nội dung',
                    width: 15,
                },*/
                content_info: {
                    name: 'content_info',
                    type: "String",
                    label: 'Nội dung',
                    width: 15,
                    class: 'center',
                    sortable: false,
                    /*filter: { type: 'DateRange', match: 'custom'},*/
                    computed: (data) => {
                        //var content_info = `<p style="text-align: left;margin-bottom: 4px;">${data.content}</p>`;
                        var content_data = "";
                        if (data.obj_wr_product_serial_number){
                            if (data.obj_wr_product_serial_number.service_type){
                                if (data.obj_wr_product_serial_number.service_type.name){
                                    content_data = data.obj_wr_product_serial_number.service_type.name;
                                }
                            }
                        }
                        var content_info = `<p style="text-align: left;margin-bottom: 4px;">${content_data}</p>`;
                        if (data.obj_wr_product_serial_number){
                            var id_wr_product = (data.obj_wr_product_serial_number.id) ? data.obj_wr_product_serial_number.id:'';
                            var code_wr = (data.obj_wr_product_serial_number.obj_warranty_repair) ? data.obj_wr_product_serial_number.obj_warranty_repair.code:'';
                            content_info += `<p style="text-align: left;margin-bottom: 4px;">Mã dịch vụ: <a href="/admin/warranty-repair/view-detail/${id_wr_product}">${code_wr}</a></p>`;
                        }
                        data.content_info = content_info
                    }
                },
                process_status: {
                    name: 'process_status',
                    label: 'Trạng thái thực hiện',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 15,
                    disabled: true,
                    options: [
                        { "value": 0, "label": "Chờ thực hiện" },
                        { "value": 1, "label": "Đã thực hiện" },
                        { "value": 2, "label": "KH từ chối" },
                        { "value": 3, "label": "Không thực hiện" },
                        { "value": 4, "label": "Đề nghị hủy SP" },
                        { "value": 5, "label": "Cập nhật" },
                        { "value": 6, "label": "Chờ giao trả" },
                        { "value": 7, "label": "Hoàn thành" },
                        { "value": 8, "label": "Gửi yêu cầu" },
                        { "value": 9, "label": "Đồng ý tiếp nhận" },
                        { "value": 10, "label": "Từ chối tiếp nhận" },
                        { "value": 11, "label": "Đã hỗ trợ xong" },
                    ],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
            fied_detail: {
                refs: 'content obj_wr_product_serial_number { id serial_user_id serial_number_id warranty_repair_id obj_warranty_repair { id code } service_type { name } } obj_modifier { id full_name organization_account { organization { name id } }  } ',
                display: false
            },
        },)
    }

}